import React, { useState, useEffect } from "react"

import { Offcanvas, Button } from "react-bootstrap"

import { ChevronRight, ArrowLeftCircle } from "react-feather"

import SearchInput from "../SearchInput/SearchInput"

// import "./App.css";
import "./OffcanvasClientSwitcher.css"

import { useAppContext } from "../../AppContext"

// const clients = [
//   "AAG - Flynn Applebee's",
//   "AARK - Apple Arkansas",
//   "ABC - American Bread Company",
//   "ACENTRAL - Apple Central",
//   "ACGBBQ - Sonnys BBQ",
// ]

// const parsedClients = clients.map((client) => {
//   const [initials, name] = client.split(" - ")
//   return { initials, name }
// })

function OffcanvasClientSwitcher(props) {
  // const [selectedClient, setSelectedClient] = useState(null)
  const { clientList, selectedClient, setSelectedClient } = useAppContext()
  const [showClientOptions, setShowClientOptions] = useState(false)

  useEffect(() => {
    if (props.show) {
      // just to reset that
      setShowClientOptions(false)
    }
  }, [props.show])

  const handleClientClick = (client) => {
    setSelectedClient(client)
    setShowClientOptions(true)
  }

  const handleBack = () => {
    setShowClientOptions(false)
  }

  const handleDefaultOption = (option) => {
    // TODO: select client and make default
    if (option === "make-default") {
      // select the client and make it the default
    } else {
      // just select the client
    }

    setShowClientOptions(false)

    // when Yes/No is selected, we can close the offcanvas
    //setTimeout(() => {
      props.onClose()
    //}, 300)
  }

  return (
    <>
      <Offcanvas
        show={props.show}
        onHide={props.onClose}
        placement="end"
        className="oc-custom client-switcher"
      >
        <Offcanvas.Header style={{ justifyContent: "normal" }}>
          {/* <Offcanvas.Title>
            {showClientOptions ? selectedClient?.name : "Select a Client"}
          </Offcanvas.Title> */}
          {showClientOptions ? (
            <>
              <ArrowLeftCircle
                color={'#004B87'}
                style={{ cursor: "pointer", marginRight: 10 }}
                size={30}
                onClick={handleBack}
              />
              <Offcanvas.Title>{selectedClient?.name}</Offcanvas.Title>
            </>
          ) : (
            <Offcanvas.Title>Select a Client</Offcanvas.Title>
          )}
          <button className="btn-close" onClick={() => {
              if (showClientOptions) {
                setShowClientOptions(false)
              } else {
                props.onClose()
              }
            }} aria-label="Close">×</button>
        </Offcanvas.Header>

        <Offcanvas.Body className="help">
          <div
            className={`slide-wrapper ${
              showClientOptions ? "show-options" : ""
            }`}
          >
            {/* Main client list */}
            <div className="panel panel-list">
              <p>
                To view a different client, select one from the list. You also
                have the option to make it your default client.
              </p>

              <SearchInput
                defaultValue=""
                onChange={console.log}
                onKeyDown={console.log}
              />

              <div className="list-container">
                {clientList?.map((client, index) => (
                  <div
                    key={index}
                    className="list-item"
                    onClick={() => handleClientClick(client)}
                  >
                    <div className="item-container">
                      <div className="avatar">
                        <img
                          src="/img/icon-client-switcher-home.svg"
                          alt="Client"
                        />
                      </div>
                      <div className="title-container">
                        <div className="title">{client.initials}</div>
                        <div className="description">{client.name}</div>
                      </div>
                      <Button variant="Hyperlink" className="chevron">
                        <ChevronRight color={"#004b87"} size={20} />
                      </Button>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Slide-in panel */}
            <div className="panel panel-options">
              <p style={{ textAlign: "center" }}>
                Would you like to make {selectedClient?.initials} - {selectedClient?.name} your default?
              </p>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  marginTop: 30,
                  paddingLeft: 50,
                  paddingRight: 50,
                }}
              >
                <button
                  type="button"
                  className="btn-modern primary"
                  onClick={() => handleDefaultOption("make-default")}
                  style={{ width: "50%" }}
                >
                  Yes
                </button>
                <button
                  type="button"
                  className="btn-modern primary"
                  onClick={() => handleDefaultOption("temporary")}
                  style={{ width: "50%" }}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  )
}

export default OffcanvasClientSwitcher
